module.exports = __webpack_public_path__ + "db9c38d3087d2c679cf4cd3a8e2b015c.svg";